import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';

if ( typeof taxTermData !== 'undefined' ) {
	( function( taxTermData ) {
		console.log( taxTermData )

		if ( ! document.getElementById( 'archive-app' ) ) {
			return
		}

		const entities = new Entities();

		let showLoadMoreButton = false;
		if ( taxTermData.posts.length >= parseInt( taxTermData.postsPerPage ) ) {
			showLoadMoreButton = true;
		}

		const state = {
			ajaxUrl: taxTermData.ajaxUrl,
			stories: taxTermData.posts,
			tax: taxTermData.tax,
			term_id: taxTermData.term_id,
			term_name: taxTermData.term_name,
			showLoadMore: showLoadMoreButton,
			postsPerPage: taxTermData.postsPerPage,
			page: 1,
		};

		const actions = {

			addFilteredStories : value => ( state, actions ) => {

				let page = state.page + 1

				actions.upPageCount()

				$.ajax({
					method: 'POST',
					data : {
						action: 'get_tax_term_data',
						page: page,
						tax: state.tax,
						term_id: state.term_id
					},
					url: state.ajaxUrl,
					success: function( response ) {
						let posts = JSON.parse( response )

						if ( 0 === posts.length ) {
							actions.disableLoadMore()
						} else {
							actions.addStories( JSON.parse( response ) )
						}

						if ( posts.length < state.postsPerPage ) {
							actions.disableLoadMore()
						}
					}
				})
			},

			upPageCount: value => state => state.page = state.page + 1,

			resetPageCount: value => state => state.page = 1,

			setStories: value => state => state.stories = value,

			addStories: value => state => state.stories = state.stories.concat( value ),

			disableLoadMore: value => state => state.showLoadMore = false,

			enableLoadMore: value => state => state.showLoadMore = true,
		}

		const StoriesList = ({ stories, state }) => {

			return (
				<div class="stories-landing__list">
					{ stories.map( story => {
						return (
							<StoryItem story={ story } state={ state } />
						)
					})}
				</div>
			)
		}

		const MediaIcon = ({ media_type }) => {

			let mediaDisplay = ''
			if ( 'string' == typeof media_type.icon ) {
				mediaDisplay = <div class="circle-icon media-circle-icon"><span class={ media_type.icon }></span></div>
			}

			if ( mediaDisplay ) {
				return mediaDisplay
			}

		}

		const StoryItem = ({ story, state }) => {

			let mediaTypeText = ( '' != story.media_type ) ? <div class="media-type">{ entities.decode( story.media_type.name ) }</div> : ''

			return (
				<div class="stories-landing__item">

					<div class="image">
						<a href={ entities.decode( story.url ) }>
							<img src={ story.image.url ? story.image.url : 'https://www.clarku.edu/centers/marsh-institute/wp-content/uploads/sites/2/2018/09/Carved-Seal-650x400-2-535x300.jpg' }
								 width={ story.image.width }
								 height={ story.image.height }
								 alt={ story.image.alt } />
							<MediaIcon media_type={ story.media_type } />
						</a>
					</div>

					<div class="text">
						<div class="h5__title">
							<a href={ entities.decode( story.url ) }>
								{ entities.decode( story.name ) }
							</a>
						</div>
						{ mediaTypeText }
					</div>

				</div>
			);
		}

		const LoadMoreButton = ({ state, actions }) => {

			const loadMoreStories = ( state, actions ) => {
				actions.upPageCount()
			}

			if ( state.showLoadMore ) {
				return (
					<button style={{display: 'block', width: '100%'}} class="reset outline-button grey in-the-news-archive__load-more-btn secondary" onclick={ () => { actions.addFilteredStories() } }>
						Load More
					</button>
				)
			}
		}

		const view = ( state, actions ) => {
			return (
				<div class="program-finder__container">
					<StoriesList stories={ state.stories } state={ state } />
					<LoadMoreButton state={ state } actions={ actions } />
				</div>
			)
		}

		const App = app( state, actions, view, document.getElementById( 'archive-app' ) )

	} ( taxTermData ) );
}



// WEBPACK FOOTER //
// ./assets/js/tax-term.js